import React from 'react'

export default class AiTo extends React.Component {
    constructor(props) {
        super(props)
        this.state = { campos: {} }
    }

    componentDidMount() {
        if (this.props.value.camposAi) {
            console.log(this.props.value.camposAi)
        }
    }

    clickCheck(e) {
        if (!this.state[e.target.name]) {
            this.setState({ [e.target.name]: true })
        } else {
            this.setState({ [e.target.name]: false })
        }
    }

    qtd(e) {
        const campos = { ...this.state.campos }
        campos[e.target.name] = e.target.value
        this.setState({ campos })
        console.log(this.state)
    }

    render() {
        return (
            <React.Fragment>
                <div className="mt-5 font-weight-bold text-left">
                    {this.props.numero} - INFRAÇÕES:
                </div>
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="primeira"
                                {...this.props}
                                value="primeira" /> &nbsp;
                            1 - Estágio não obrigatório do curso de Terapia Ocupacional em quantitativo acima do permitido na 
                            Resolução COFFITO 452/2015</label>
                    </div>
                    {this.renderPrimeira()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="segunda"
                                {...this.props}
                                value="segunda" /> &nbsp;
                            2- Estágio obrigatório de acadêmicos(as) do curso de Terapia Ocupacional com ausência de 
                            acompanhamento de docente da Instituição de Ensino Superior (IES)
                        </label>
                    </div>
                    {this.renderSegunda()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="terceira"
                                {...this.props}
                                value="terceira" /> &nbsp;
                            3- Exercício ilegal da profissão de terapeuta ocupacional.
                        </label>
                    </div>
                    {this.renderTerceira()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="quarta"
                                {...this.props}
                                value="quarta" /> &nbsp;
                            4- Prática de atividades da Terapia Ocupacional por pessoa não habilitada.
                        </label>
                    </div>
                    {this.renderQuarta()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="quinta"
                                {...this.props}
                                value="quinta" /> &nbsp;
                            5- Delegação de função privativa do profissional terapeuta ocupacional.
                        </label>
                    </div>
                    {this.renderQuinta()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="sexta"
                                {...this.props}
                                value="sexta" /> &nbsp;
                             6- Empresa não possui a Declaração de Regularidade para Funcionamento (DRF) do serviço.
                        </label>
                    </div>
                    {this.renderSexta()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="setima"
                                {...this.props}
                                value="setima" /> &nbsp;
                            7- Ausência do responsável técnico de Terapia Ocupacional.
                        </label>
                    </div>
                    {this.renderSetima()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="oitava"
                                {...this.props}
                                value="oitava" /> &nbsp;
                            8- Profissional com Licença Temporária de Terapia Ocupacional vencida.
                        </label>
                    </div>
                    {this.renderOitava()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="nona"
                                {...this.props}
                                value="nona" /> &nbsp;
                            9- Falta de registro das atividades assistenciais terapêuticas, no que tange sobre 
                            a obrigatoriedade do registro em prontuário pelo terapeuta ocupacional, da guarda e 
                            do seu descarte.
                            (Responsável Técnico)
                        </label>
                    </div>
                    {this.renderNona()}
                </div>
                <hr />
                {/* <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="decima"
                                {...this.props}
                                value="decima" /> &nbsp;
                            10- Descumprimento a RDC-07.
                        </label>
                    </div>
                    {this.renderDecima()}
                </div>
                <hr /> */}
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="onze"
                                {...this.props}
                                value="onze" /> &nbsp;
                            10- Falta de registro de consultório.
                        </label>
                    </div>
                    {this.renderOnze()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="doze"
                                {...this.props}
                                value="doze" /> &nbsp;
                            11- Débitos com obrigações pecuniárias.
                        </label>
                    </div>
                    {this.renderDoze()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="treze"
                                {...this.props}
                                value="treze" /> &nbsp;
                            12- Descumprimento dos parâmetros assistenciais terapêuticos.(Responsável Técnico)
                        </label>
                    </div>
                    {this.renderTreze()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="quatorze"
                                {...this.props}
                                value="quatorze" /> &nbsp;
                            13- Descumprimento da Portaria CREFITO-1 Nº 046/2020
                        </label>
                    </div>
                    {this.renderQuatorze()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="quinze"
                                {...this.props}
                                value="quinze" /> &nbsp;
                            14- Descumprimento da legislação referente ao registro em prontuário dos 
                            terapeutas ocupacionais.
                        </label>
                    </div>
                    {this.renderQuinze()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="dezesseis"
                                {...this.props}
                                value="dezesseis" /> &nbsp;
                            15- Publicidade irregular - exposição de pacientes.
                        </label>
                    </div>
                    {this.renderDezesseis()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="dezessete"
                                {...this.props}
                                value="dezessete" /> &nbsp;
                            16- Publicidade irregular
                        </label>
                    </div>
                    {this.renderDezessete()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="dezoito"
                                {...this.props}
                                value="dezoito" /> &nbsp;
                            17- Falta de Registro de Pessoa Jurídica junto ao CREFITO-1.
                        </label>
                    </div>
                    {this.renderDezoito()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="dezenove"
                                {...this.props}
                                value="dezenove" /> &nbsp;
                            18- Profissional sem registro de inscrição secundária.
                        </label>
                    </div>
                    {this.renderDezenove()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="vinte"
                                {...this.props}
                                value="vinte" /> &nbsp;
                            19- Desvio de circunscrição, pois o terapeuta ocupacional não realizou a transferência.
                        </label>
                    </div>
                    {this.renderVinte()}
                </div>
                <hr />
                <div className="row mt-3 text-left">
                    <div className="form-check form-check-inline col-12">
                        <label className="ml-2">
                            <input id="infracoes" type="checkbox" onClick={e => this.clickCheck(e)}
                                name="vinteUm"
                                {...this.props}
                                value="vinteUm" /> &nbsp;
                            20- Falta de cadastro do estabelecimento fiscalizado de Terapia Ocupacional.
                        </label>
                    </div>
                    {this.renderVinteUm()}
                </div>
                <hr />
            </React.Fragment>
        )
    }

    renderPrimeira() {
        if (this.state.primeira == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="primeiraQtd" />
                    </div>
                    {this.renderCampos1()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderSegunda() {
        if (this.state.segunda == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="segundaQtd" />
                    </div>
                    {this.renderCampos2()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderTerceira() {
        if (this.state.terceira == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="terceiraQtd" />
                    </div>
                    {this.renderCampos3()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderQuarta() {
        if (this.state.quarta == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="quartaQtd" />
                    </div>
                    {this.renderCampos4()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderQuinta() {
        if (this.state.quinta == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="quintaQtd" />
                    </div>
                    {this.renderCampos5()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderSexta() {
        if (this.state.sexta == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="aiNumero6"
                            {...this.props}
                            value={this.props.aiNumero6} />
                    </div>
                    <label className="col-3 col-md-2">Nome da Empresa:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="autuadoEmpresa6"
                            {...this.props}
                            value={this.props.autuadoEmpresa} />
                    </div>
                    <label className="col-3 col-md-2">CNPJ:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="cnpj6"
                            {...this.props}
                            value={this.props.cnpj} />
                    </div>
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderSetima() {
        if (this.state.setima == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="aiNumero7"
                            {...this.props}
                            value={this.props.aiNumero7} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Estabelecimento:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="autuadoEmpresa7"
                            {...this.props}
                            value={this.props.autuadoEmpresa} />
                    </div>
                    <label className="col-3 col-md-2">CNPJ:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="cnpj7"
                            {...this.props}
                            value={this.props.cnpj} />
                    </div>
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderOitava() {
        if (this.state.oitava == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="oitavaQtd" />
                    </div>
                    {this.renderCampos8()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderNona() {
        if (this.state.nona == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="nonaQtd" />
                    </div>
                    {this.renderCampos9()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderDecima() {
        if (this.state.decima == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="aiNumero10"
                            {...this.props}
                            value={this.props.aiNumero10} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="autuadoNome10"
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="inscricaoNumero10"
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                    <label className="col-3 col-md-2">Turnos:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="turnos"
                            {...this.props}
                            value={this.props.turnos} />
                    </div>
                    <label className="col-3 col-md-2">Setores:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="setores"
                            {...this.props}
                            value={this.props.setores} />
                    </div>
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderOnze() {
        if (this.state.onze == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="aiNumero11"
                            {...this.props}
                            value={this.props.aiNumero11} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="autuadoNome11"
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="inscricaoNumero11"
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderDoze() {
        if (this.state.doze == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="dozeQtd" />
                    </div>
                    {this.renderCampos12()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderTreze() {
        if (this.state.treze == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="trezeQtd" />
                    </div>
                    {this.renderCampos13()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderQuatorze() {
        if (this.state.quatorze == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="quatorzeQtd" />
                    </div>
                    {this.renderCampos14()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderQuinze() {
        if (this.state.quinze == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="quinzeQtd" />
                    </div>
                    {this.renderCampos15()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderDezesseis() {
        if (this.state.dezesseis == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="dezesseisQtd" />
                    </div>
                    {this.renderCampos16()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderDezessete() {
        if (this.state.dezessete == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="dezesseteQtd" />
                    </div>
                    {this.renderCampos17()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderDezoito() {
        if (this.state.dezoito == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="aiNumero18"
                            {...this.props}
                            value={this.props.aiNumero18} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="autuadoNome18"
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">CNPJ:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="cnpj18"
                            {...this.props}
                            value={this.props.cnpj} />
                    </div>
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderDezenove() {
        if (this.state.dezenove == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="dezenoveQtd" />
                    </div>
                    {this.renderCampos19()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderVinte() {
        if (this.state.vinte == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Quantidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="number" className="form-control" onChange={e => this.qtd(e)}
                            name="vinteQtd" />
                    </div>
                    {this.renderCampos20()}
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderVinteUm() {
        if (this.state.vinteUm == true) {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="aiNumero21"
                            {...this.props}
                            value={this.props.aiNumero21} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="autuadoNome21"
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">CNPJ:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name="cnpj21"
                            {...this.props}
                            value={this.props.cnpj} />
                    </div>
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderCampos1() {
        let select = []
        for (let n = 0; n < this.state.campos.primeiraQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero1-${n}`}
                            {...this.props}
                            value={this.props.aiNumero1} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome1-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`inscricaoNumero1-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos2() {
        let select = []
        for (let n = 0; n < this.state.campos.segundaQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero2-${n}`}
                            {...this.props}
                            value={this.props.aiNumero2} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome2-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`inscricaoNumero2-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                    <label className="col-3 col-md-2">Local do estágio:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`localEstagio2-${n}`}
                            {...this.props}
                            value={this.props.localEstagio} />
                    </div>
                    <label className="col-3 col-md-2">Instituição de Ensino:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`instituicaoEnsino2-${n}`}
                            {...this.props}
                            value={this.props.instituicaoEnsino} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos3() {
        let select = []
        for (let n = 0; n < this.state.campos.terceiraQtd; n++) {
            select.push(
                <React.Fragment> 
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero3-${n}`}
                            {...this.props}
                            value={this.props.aiNumero3} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Estabelecimento:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`estabelecimentoNome3-${n}`}
                            {...this.props}
                            value={this.props.estabelecimentoNome} />
                    </div>
                    <label className="col-3 col-md-2">CNPJ:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`cnpj3-${n}`}
                            {...this.props}
                            value={this.props.cnpj} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Leigo:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`leigoNome3-${n}`}
                            {...this.props}
                            value={this.props.leigoNome} />
                    </div>
                    <label className="col-3 col-md-2">RG do Leigo:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`rgLeigo3-${n}`}
                            {...this.props}
                            value={this.props.rgLeigo} />
                    </div>
                    <label className="col-3 col-md-2">CPF do Leigo:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`cpfLeigo3-${n}`}
                            {...this.props}
                            value={this.props.cpfLeigo} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos4() {
        let select = []
        for (let n = 0; n < this.state.campos.quartaQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero4-${n}`}
                            {...this.props}
                            value={this.props.aiNumero4} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome4-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">RG do Leigo:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`rgLeigo4-${n}`}
                            {...this.props}
                            value={this.props.rgLeigo} />
                    </div>
                    <label className="col-3 col-md-2">CPF do Leigo:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`cpfLeigo4-${n}`}
                            {...this.props}
                            value={this.props.cpfLeigo} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos5() {
        let select = []
        for (let n = 0; n < this.state.campos.quintaQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero5-${n}`}
                            {...this.props}
                            value={this.props.aiNumero5} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome5-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`inscricaoNumero5-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Leigo:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`leigoNome5-${n}`}
                            {...this.props}
                            value={this.props.leigoNome} />
                    </div>
                    <label className="col-3 col-md-2">RG do Leigo:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`rgLeigo5-${n}`}
                            {...this.props}
                            value={this.props.rgLeigo} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos8() {
        let select = []
        for (let n = 0; n < this.state.campos.oitavaQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero8-${n}`}
                            {...this.props}
                            value={this.props.aiNumero88} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome8-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`inscricaoNumero8-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                    <label className="col-3 col-md-2">Vencimento do LTF:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="date" className="form-control"
                            id="camposAi"
                            name={`ltf-${n}`}
                            {...this.props}
                            value={this.props.ltf} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos9() {
        let select = []
        for (let n = 0; n < this.state.campos.nonaQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero9-${n}`}
                            {...this.props}
                            value={this.props.aiNumero9} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome9-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`inscricaoNumero9-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos12() {
        let select = []
        for (let n = 0; n < this.state.campos.dozeQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero12-${n}`}
                            {...this.props}
                            value={this.props.aiNumero9} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome12-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`inscricaoNumero12-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                    <label className="col-3 col-md-2">Anuidades:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`anuidades-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                    <label className="col-3 col-md-2">Multa Eleitoral:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`multa-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                    <label className="col-3 col-md-2">Parcelamento das anuidades:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`parcelamento-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos13() {
        let select = []
        for (let n = 0; n < this.state.campos.trezeQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero13-${n}`}
                            {...this.props}
                            value={this.props.aiNumero13} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome13-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`inscricaoNumero13-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos14() {
        let select = []
        for (let n = 0; n < this.state.campos.quatorzeQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero14-${n}`}
                            {...this.props}
                            value={this.props.aiNumero14} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome14-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Nº de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`cnpj14-${n}`}
                            {...this.props}
                            value={this.props.cnpj} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos15() {
        let select = []
        for (let n = 0; n < this.state.campos.quinzeQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero15-${n}`}
                            {...this.props}
                            value={this.props.aiNumero15} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome15-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`inscricaoNumero15-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos16() {
        let select = []
        for (let n = 0; n < this.state.campos.dezesseisQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero16-${n}`}
                            {...this.props}
                            value={this.props.aiNumero16} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome16-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`inscricaoNumero16-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos17() {
        let select = []
        for (let n = 0; n < this.state.campos.dezesseteQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero17-${n}`}
                            {...this.props}
                            value={this.props.aiNumero17} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome17-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`inscricaoNumero17-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                    <label className="col-3 col-md-2">Publicidade:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`publicidade17-${n}`}
                            {...this.props}
                            value={this.props.publicidade} />
                    </div>
                    <label className="col-3 col-md-2">Endereço:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`endereco17-${n}`}
                            {...this.props}
                            value={this.props.endereco} />
                    </div>
                    <label className="col-3 col-md-2">CEP:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`cep17-${n}`}
                            {...this.props}
                            value={this.props.cep} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos19() {
        let select = []
        for (let n = 0; n < this.state.campos.dezenoveQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero19-${n}`}
                            {...this.props}
                            value={this.props.aiNumero19} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome19-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`inscricaoNumero19-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                    <label className="col-3 col-md-2">Prazo para solicitar Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`prazoInscricao-${n}`}
                            {...this.props}
                            value={this.props.prazoInscricao} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }

    renderCampos20() {
        let select = []
        for (let n = 0; n < this.state.campos.vinteQtd; n++) {
            select.push(
                <React.Fragment>
                    <label className="col-3 col-md-2">Número do A.I.:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`aiNumero20-${n}`}
                            {...this.props}
                            value={this.props.aiNumero20} />
                    </div>
                    <label className="col-3 col-md-2">Nome do Autuado:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`autuadoNome20-${n}`}
                            {...this.props}
                            value={this.props.autuadoNome} />
                    </div>
                    <label className="col-3 col-md-2">Número de Inscrição:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`inscricaoNumero20-${n}`}
                            {...this.props}
                            value={this.props.inscricaoNumero} />
                    </div>
                    <label className="col-3 col-md-2">CREFITO antigo:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`crefitoTransferencia1-${n}`}
                            {...this.props}
                            value={this.props.crefitoTransferencia1} />
                    </div>
                    <label className="col-3 col-md-2">CREFITO novo:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="text" className="form-control"
                            id="camposAi"
                            name={`crefitoTransferencia2-${n}`}
                            {...this.props}
                            value={this.props.crefitoTransferencia2} />
                    </div>
                </React.Fragment>
            )
        }
        return select
    }
}